export const validateBep20UsdtAddress = (address) => {
  // Regular expression to match the BEP-20 address format
  const regex = /^0x[a-fA-F0-9]{40}$/;
  return regex.test(address);
};
